/**
 * Fase da disputa de governador (§13.1.4): `no_race` (UF fora das disputas do 2º turno), `no_data` (nenhuma seção),
 * `counting` (seções > 0, sem decisão) e `decided` (`mathDecision` ou `tseResult`). `runoff` só existe no arquivo do
 * 1º turno (§11.5) e nunca sai daqui. Puro: mesma resposta para o mesmo `ResultsView` (ao vivo ou replay).
 */
import type { PlaceView, RacePhase, ResultsView, UfCode } from './types';

/** Campos de que a fase depende (a vista da UF, `ResultsView.governor[uf]`). */
export type RacePhaseInput = Pick<PlaceView, 'sectionsFraction' | 'mathDecision' | 'tseResult'>;

/** Fase a partir da vista da UF; `undefined` = UF sem 2º turno para governador. */
export function racePhaseOf(g: RacePhaseInput | undefined): RacePhase {
  if (g === undefined) return 'no_race';
  if (g.mathDecision !== null || g.tseResult !== null) return 'decided';
  if (g.sectionsFraction === 0) return 'no_data';
  return 'counting';
}

/** §13.1.4: fase da disputa de governador da UF na vista. */
export function racePhase(uf: UfCode, view: ResultsView): RacePhase {
  return racePhaseOf(view.governor[uf]);
}
